import { render, staticRenderFns } from "./SchoolTypePage.vue?vue&type=template&id=2a0b8a0c"
import script from "./SchoolTypePage.vue?vue&type=script&lang=js"
export * from "./SchoolTypePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports